import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCPE2sQpLWeAAONryqW7GjCg2m1C4QqEsI",
  authDomain: "pointshub-517bd.firebaseapp.com",
  projectId: "pointshub-517bd",
  storageBucket: "pointshub-517bd.firebasestorage.app",
  messagingSenderId: "806902896313",
  appId: "1:806902896313:web:350b7f20e23ac393476d68",
  measurementId: "G-LL2CE5G3T1"
};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);